export default __webpack_public_path__ + "static/media/bunny@2x.10550652.png";